export default __webpack_public_path__ + "img/283371b4fb942950cbcf49a83218e9c0.png";